<template>
    <div data-id="asset-linked">
        <div class="row w-100 my-0 pb-0 col-md-12">
            <div class="col-md-12 mb-4">
                <p class="text-muted">
                    Attach an asset to existing PIM data (Brands, Categories & Products)
                </p>
            </div>
        </div>
        <div class="row w-100 my-0 pb-0 col-md-12">
            <h4 class="pb-2 col-md-6">Add Link</h4>
        </div>
        <div class="row w-100 pb-0 mt-0 col-md-12">
            <div class="col-md-6 d-flex flex-column">
                <div class="d-flex">
                    <select class="form-select form-control"
                        data-id="select-link-type"
                        v-model="selectedLinkType"
                    >
                        <option>Brands</option>
                        <option>Products</option>
                        <option>Categories</option>
                    </select>
                </div>
                <transition name="fade">
                    <div class="d-flex flex-column select-linked">
                        <select-item-from-api-provided-list
                            v-if="selectedLinkType === 'Products'"
                            :api="'pimapi/products'"
                            :api-type="'meta'"
                            :list-label="'Select Product'"
                            :columns="['name']"
                            :results-per-page="10"
                            small
                            ref="selectFromApi"
                            @selection="handleLinkSelection"
                            key="productsSelection"
                        >
                        </select-item-from-api-provided-list>
                        <select-item-from-api-provided-list
                            v-else-if="selectedLinkType === 'Brands'"
                            :api="'brands/grid'"
                            :api-type="'grid'"
                            :list-label="'Select Brand'"
                            :columns="['name']"
                            :results-per-page="10"
                            small
                            ref="selectFromApi"
                            @selection="handleLinkSelection"
                            key="brandsSelection"
                        >
                        </select-item-from-api-provided-list>
                        <select-item-from-api-provided-list
                            v-else-if="selectedLinkType === 'Categories'"
                            :api="'categories/grid'"
                            :api-type="'grid'"
                            :list-label="'Select Category'"
                            :columns="['name']"
                            :results-per-page="10"
                            small
                            ref="selectFromApi"
                            @selection="handleLinkSelection"
                            key="categoriesSelection"
                        >
                        </select-item-from-api-provided-list>
                        <div class="d-flex flex-column">
                            <div v-if="assetTypesMap.displayableImageTypes.includes(asset.asset_type_id)">
                                <label for="">
                                    Save as thumbnail
                                </label> 
                                <input type="checkbox" class="form-control asset-private" name="" id="" v-model="selectedEntity.thumbnail" data-id="thumbnail-checkbox">
                            </div>
                            <button data-id="asset-link-submit" class="btn btn-primary mt-2" @click="handleLinkAsset" :disabled="linkLoading">
                                Attach Selected
                            </button>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div class="row w-100 my-0 pb-0 col-md-12 mt-5">
            <h4 class="pb-2 col-md-6">Linked Items</h4>
        </div>
        <div class="row w-100 mt-0 pb-0 col-md-12">
            <div class="col-md-12 pt-2 pb-4 linked-items">
                <div v-if="linkedItems.products.length">
                    <h5>Linked Products</h5>
                    <div v-for="(item, index) in linkedItems.products" 
                        :key="item.id" 
                        class="d-flex align-items-start justify-content-between"
                        :class="{ 'mt-2':  index > 0 }"
                    >
                        <a :href="'/products/' + item.id + '/edit'" class="text-dark px-0">
                            {{ item.name }}
                        </a>
                        <button class="btn btn-sm btn-danger" @click="unlinkProductAsset(item.id)">
                            Unlink
                        </button>
                    </div>
                </div>
                <div v-else class="font-weight-bold">
                    No linked products
                </div>
                <div v-if="linkedItems.brands.length" class="mt-5">
                    <h5>Linked Brands</h5>
                    <div v-for="(item, index) in linkedItems.brands" 
                        :key="item.id" 
                        class="d-flex align-items-start justify-content-between"
                        :class="{ 'mt-2':  index > 0 }"
                    >
                        <a :href="'/brands/' + item.id + '/edit'" class="text-dark px-0">
                            {{ item.name }}
                        </a>
                        <button class="btn btn-sm btn-danger" @click="unlinkBrandAsset(item.id)">
                            Unlink
                        </button>
                    </div>
                </div>
                <div v-else class="font-weight-bold mt-5">
                    No linked brands
                </div>
                <div v-if="linkedItems.categories.length" class="mt-5">
                    <h5>Linked Categories</h5>
                    <div v-for="(item, index) in linkedItems.categories" 
                        :key="item.id" 
                        class="d-flex align-items-start justify-content-between"
                        :class="{ 'mt-2':  index > 0 }"
                    >
                        <a :href="'/categories/' + item.id + '/edit'" class="text-dark px-0">
                            {{ item.name }}
                        </a>
                        <button class="btn btn-sm btn-danger" @click="unlinkCategoryAsset(item.id)">
                            Unlink
                        </button>
                    </div>
                </div>
                <div v-else class="font-weight-bold mt-5">
                    No linked categories
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import selectItemFromApiProvidedListVue from '../generic/select-item-from-api-provided-list.vue';

const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: "asset-linked",
    props: {
        asset: {
            required: true,
            type: Object
        },
        assetTypesMap: {
            required: true,
            type: Object
        }
    },
    components: {
        "select-item-from-api-provided-list": selectItemFromApiProvidedListVue
    },
    data() {
        return {
            linkLoading: false,
            linkedItems: {
                brands: [],
                products: [],
                categories: []
            },
            selectedLinkType: 'Products',
            selectedEntity: {
                id: '',
                thumbnail: false
            },
        }
    },
    mounted() {
        this.fetchLinkedItems();
    },
    methods: {
        fetchLinkedItems() {
            axios.get(base_url + '/pimapi/assets/' + this.asset.id + '/linked')
                .then(function(response) {
                    this.linkedItems.categories = response.data.payload.categories;
                    this.linkedItems.products = response.data.payload.products;
                    this.linkedItems.brands = response.data.payload.brands;
                }.bind(this))
                .catch(function(err) {
                    console.log(err);
                    this.$emit("alert", {
                        status: "alert-danger",
                        message: err.response.data.message || 'There was an error, please try again later.'
                    });
            }.bind(this));
        },
        handleLinkSelection(value) {
            this.selectedEntity.id = value.id;
        },
        handleLinkAsset() {
            this.linkLoading = true;

            if (this.selectedLinkType === "Products") {
                this.linkProductAsset();
            }

            if (this.selectedLinkType === "Categories") {
                this.linkCategoryAsset();
            }

            if (this.selectedLinkType === "Brands") {
                this.linkBrandAsset();
            }
        },
        linkBrandAsset() {
            const brandUrl = 
                `${base_url}/pimapi/assets/${this.asset.id}/brand/${this.selectedEntity.id}`;

            axios.put(brandUrl, { isThumbnail: this.selectedEntity.thumbnail })
                .then(function(response) {
                    this.$emit("alert", {
                        status: "alert-success",
                        message: "Success, asset updated."
                    });

                setTimeout(function() {
                    window.location.reload();
                }, 2500);
                }.bind(this))
                .catch(function(err) {
                    console.log(err);
                    this.$emit("alert", {
                        status: "alert-danger",
                        message: err.response.data.message || 'There was an error, please try again later.'
                    });
                }.bind(this));
        },
        unlinkBrandAsset(brandId) {
            const brandUrl = 
                `${base_url}/pimapi/assets/${this.asset.id}/brand/${brandId}`;

            axios.delete(brandUrl)
                .then(function(response) {       
                    this.linkLoading = false;                                 
                    this.$emit("alert", {
                        status: "alert-success",
                        message: "Success, asset unlinked"
                    });

                    let newLinkedBrands = this.linkedItems.brands;
                        newLinkedBrands = newLinkedBrands.reduce(function(arr, curr) {
                            if (curr.id !== brandId) {
                                arr.push(curr); 
                            }

                            return arr;
                        }, []);

                    this.linkedItems.brands = newLinkedBrands;
                }.bind(this))
                .catch(function(err) {
                    this.linkLoading = false;             
                    console.log(err);

                    this.$emit("alert", {
                        status: "alert-danger",
                        message: err.response.data.message || 'There was an error, please try again later.'
                    }); 
                }.bind(this));
        },
        linkCategoryAsset() {
            const categoryUrl = 
                `${base_url}/pimapi/assets/${this.asset.id}/category/${this.selectedEntity.id}`;

            axios.put(categoryUrl, { isThumbnail: this.selectedEntity.thumbnail })
                .then(function(response) {
                    this.$emit("alert", {
                        status: "alert-success",
                        message: "Success, asset updated."
                    });

                    setTimeout(function() {
                        window.location.reload();
                    }, 2500);
                }.bind(this))
                .catch(function(err) {
                    console.log(err);
                    this.$emit("alert", {
                        status: "alert-danger",
                        message: err.response.data.message || 'There was an error, please try again later.'
                    });
                }.bind(this));
        },
        unlinkCategoryAsset(categoryId) {
            const categoryUrl = 
                `${base_url}/pimapi/assets/${this.asset.id}/category/${categoryId}`;

            axios.delete(categoryUrl)
                .then(function(response) {             
                    this.linkLoading = false;                    
                    this.$emit("alert", {
                        status: "alert-success",
                        message: "Success, asset unlinked"
                    });

                    let newLinkedCategories = this.linkedItems.categories;

                    newLinkedCategories = newLinkedCategories.reduce(function(arr, curr) {
                        if (curr.id !== categoryId) {
                            arr.push(curr); 
                        }

                        return arr;
                    }, []);

                    this.linkedItems.categories = newLinkedCategories;
                }.bind(this))
                .catch(function(err) {
                    this.linkLoading = false;             
                    console.log(err);

                    this.$emit("alert", {
                        status: "alert-danger",
                        message: err.response.data.message || 'There was an error, please try again later.'
                    });
                }.bind(this));
        },
        linkProductAsset() {
            const productUrl = 
                `${base_url}/pimapi/assets/${this.asset.id}/product/${this.selectedEntity.id}`;

            axios.put(productUrl, { isThumbnail: this.selectedEntity.thumbnail})
                .then(function(response) {                    
                    this.$emit("alert", {
                        status: "alert-success",
                        message: "Success, asset updated."
                    });

                    setTimeout(function() {
                        window.location.reload();
                    }, 2500);
                }.bind(this))
                .catch(function(err) {
                    console.log(err);
                    this.$emit("alert", {
                        status: "alert-danger",
                        message: err.response.data.message || 'There was an error, please try again later.'
                    });
                }.bind(this));
        },
        unlinkProductAsset(productId) {
            const productUrl = 
                `${base_url}/pimapi/assets/${this.asset.id}/product/${productId}`;

            axios.delete(productUrl)
                .then(function(response) {     
                    this.linkLoading = false;                            
                    this.$emit("alert", {
                        status: "alert-success",
                        message: "Success, asset unlinked"
                    });

                    let newLinkedProducts = this.linkedItems.products;

                    newLinkedProducts = newLinkedProducts.reduce(function(arr, curr) {
                        if (curr.id !== productId) {
                            arr.push(curr); 
                        }

                        return arr;
                    }, []);

                    this.linkedItems.products = newLinkedProducts;
                }.bind(this))
                .catch(function(err) {
                    this.linkLoading = false;             
                    console.log(err);
                    this.$emit("alert", {
                        status: "alert-danger",
                        message: err.response.data.message || 'There was an error, please try again later.'
                    });
                }.bind(this));
        },
    }
}
</script>
<style scoped lang="scss">
.asset-private {
    width: 38px;
}

.select-linked {
    min-width: 22rem;
    max-width: 32rem;
}

.linked-items {
    max-width: 32rem;
}
</style>